// extracted by mini-css-extract-plugin
module.exports = {"SLocationResultList":"LocationResultList_SLocationResultList__Ao5ch","SH1":"LocationResultList_SH1__9Scgo","SLocationItem":"LocationResultList_SLocationItem___jldQ"};